import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useLogin = () => {
  return useMutation((creds) => {
    return axiosPost("/api/cw/login", creds);
  });
};

export default useLogin;
